import React from "react";

import { AccordionItemPanel } from "react-accessible-accordion";

export default ({ children }) => {
  return (
    <AccordionItemPanel className="accordionItemPanel">
      {children}
    </AccordionItemPanel>
  );
};
